import { useCompose } from "../context";

export const useCurrentContactDetailSelection = () => {
    const { state } = useCompose();

    return state.contactDetails;
};
